<div class="container">
  <span class="title">Tours guiados</span>
  <div class="accordions-container">
    <app-accordion title="Facs" [roundContent]="true" [isOpen]="isOpen">
      <div class="cards-container">
        <app-card-info class="card-info" [card]="card" (click)="cardClicked(card)" *ngFor="let card of cards"></app-card-info>
      </div>
    </app-accordion>
  </div>
</div>